export enum MessageTypeEnum {
  CUSTOMER_MESSAGE = 'CUSTOMER_MESSAGE',
  ANSWERED_BY_ADVISOR = 'ANSWERED_BY_ADVISOR',
}
